import script from "./followMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./followMaterial.vue?vue&type=script&setup=true&lang=js"

import "./followMaterial.vue?vue&type=style&index=0&id=514940a0&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514940a0"]])

export default __exports__